// Owner Recapitalization Loan — query keys for the composer's letter picker and
// recap bundle pre-check (the stale-after-save gate keeps every queryKey literal
// in a *Keys file). The template and bundle lists keep the composer's existing
// prefixes, so the invalidations that reach those lists reach these too.

export const conditionalApprovalLetterKeys = {
  all: ["letter-options"] as const,
  options: (dealId: string | null) => ["letter-options", dealId] as const,
  /** Every active template (no audience filter): a deal's letters are offered
   *  whatever the recipient's party type (the chain routes them to the deal's
   *  parties, not the package recipient). */
  allActiveTemplates: ["collection-templates", "active", null] as const,
  /** The composer's bundle list, read for the deal so the server can hide the
   *  recap bundles on an Acquisition deal and flag them on a recap deal. */
  composerBundles: (partyRole: string | null, dealId: string | null) =>
    ["collection-bundles", "active", partyRole, dealId] as const,
};
